module.exports = __webpack_public_path__ + "img/case65.db00917c.png";